Ext.define('SA.RequestsCache', {
    constructor(requests) {
        this.cache = new Map();

        this.requests = requests;
    },

    get(args) {
        var key = JSON.stringify(args);

        if (!this.cache.has(key)) {
            this.cache.set(key, this.requests.get(args).catch(e => {
                this.cache.delete(key);

                throw e;
            }));
        }

        return this.cache.get(key);
    }
});